<div id="spinner" class="spinner" role="img" aria-live="assertive" aria-atomic="true" aria-label="Loading...">
  <div>
    <div class="bounce1 dots"></div>
    <div class="bounce2 dots"></div>
    <div class="bounce3 dots"></div>
  </div>
</div>
